// Old SignIn component kept for reference but route removed
// import SignIn from '@/views/SignIn.vue';
import SignInMFASetup from '@/views/SignInMFASetup.vue';
import SignInVerifyMFACode from '@/views/SignInVerifyMFACode.vue';
import SignInChangePassword from '@/views/SignInChangePassword.vue';
import SignInVerifyEmailCode from '@/views/SignInVerifyEmailCode.vue';

import { views } from '@/router/constants';
import { publicGuard } from '@/router/guards';

export default [
  // Old /sign-in route removed - now using ModernSignIn on root path
  // {
  //   path: '/sign-in',
  //   name: views.SIGN_IN,
  //   component: SignIn,
  //   meta: {
  //     allowedForUnauthorizedUsers: true,
  //   },
  //   beforeEnter: publicGuard,
  // },
  {
    path: '/sign-in/change-password',
    name: views.SIGN_IN_CHANGE_PASSWORD,
    component: SignInChangePassword,
    meta: {
      allowedForUnauthorizedUsers: true,
    },
    beforeEnter: publicGuard,
  },
  {
    path: '/sign-in/mfa-setup',
    name: views.SIGN_IN_MFA_SETUP,
    component: SignInMFASetup,
    meta: {
      allowedForUnauthorizedUsers: true,
    },
    beforeEnter: publicGuard,
  },
  {
    path: '/sign-in/mfa-code',
    name: views.SIGN_IN_MFA_CODE,
    component: SignInVerifyMFACode,
    meta: {
      allowedForUnauthorizedUsers: true,
    },
    beforeEnter: publicGuard,
  },
  {
    path: '/sign-in/verify-email',
    name: views.SIGN_IN_VERIFY_EMAIL,
    component: SignInVerifyEmailCode,
    beforeEnter: publicGuard,
  },
];
